import AccountNav from "../components/AccountNav";
import { useAuth } from "../context/AuthContext";

export default function AccountActivity() {
  const { user } = useAuth();

  const activity = [
    {
      title: "Profile accessed",
      detail: `Account dashboard opened by ${user?.full_name || "member"}.`,
      when: "Just now"
    },
    {
      title: "Listing filters used",
      detail: "Browsed listings by city and property type.",
      when: "Today"
    },
    {
      title: "Inquiry action",
      detail: "Inquiry workflow visited from property details page.",
      when: "Yesterday"
    },
    {
      title: "Account session",
      detail: "Successfully authenticated and session refreshed.",
      when: "2 days ago"
    }
  ];

  return (
    <div className="container page account-page">
      <div className="account-shell">
        <AccountNav />

        <section className="account-main">
          <div className="account-hero compact">
            <div>
              <h2>Recent Activity</h2>
              <p>Track key actions from your account and listing workflows.</p>
            </div>
          </div>

          <article className="account-card">
            <div className="activity-list">
              {activity.map((item) => (
                <div className="activity-item" key={item.title}>
                  <div className="activity-dot" />
                  <div>
                    <h4>{item.title}</h4>
                    <p>{item.detail}</p>
                  </div>
                  <span>{item.when}</span>
                </div>
              ))}
            </div>
          </article>
        </section>
      </div>
    </div>
  );
}
